<template>
  <div class="horizon-toolbar d-flex align-center justify-space-between flex-wrap gap-2" data-testid="horizon-toolbar">
    <HorizonFilter
      :horizon-filters="horizonFilters"
      :active-filters="activeFilters"
      @filter-change="$emit('filter-change', $event)"
    />
    <div class="d-flex align-center gap-2" data-testid="horizon-toolbar__right">
      <v-tooltip bottom content-class="tooltip-bottom">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            icon
            class="horizon-toolbar__action-btn shadow-off"
            :class="{ 'horizon-toolbar__action-btn--overdue-active': overDueDate }"
            @click="$emit('overdue-filter')"
            data-testid="horizon-toolbar__overdue-btn"
          >
            <v-icon small data-testid="horizon-toolbar__overdue-icon">mdi-clock-outline</v-icon>
          </v-btn>
        </template>
        <span>Task Overdue Filter</span>
      </v-tooltip>

      <div class="horizon-toolbar__divider" aria-hidden="true" />

      <lb-date-picker
        :value="dateRange"
        :max-days="maxDays"
        :min-days="minDays"
        :cycle-start="cycleStart"
        :cycle-end="cycleEnd"
        @input="onDateRangeInput"
        data-testid="date-range-selector"
      />
    </div>
  </div>
</template>

<script>
import './HorizonToolbar.scss';
import HorizonFilter from './HorizonFilter.vue';
import { HORIZON_DATE_WINDOW } from '../../../utils/horizonConstants';

/** Horizon Row 2 toolbar: dimension filter pills + date-range picker (5447). */
export default {
  name: 'HorizonToolbar',
  components: {
    HorizonFilter,
  },
  props: {
    horizonFilters: {
      type: Object,
      default: () => ({}),
    },
    activeFilters: {
      type: Object,
      default: () => ({}),
    },
    startDate: {
      type: String,
      default: '',
    },
    endDate: {
      type: String,
      default: '',
    },
    cycleStart: {
      type: String,
      default: '',
    },
    cycleEnd: {
      type: String,
      default: '',
    },
    overDueDate: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dateRange() {
      if (this.startDate && this.endDate) {
        return [this.startDate, this.endDate];
      }
      return [];
    },
    minDays() {
      return HORIZON_DATE_WINDOW.MIN_DAYS;
    },
    maxDays() {
      return HORIZON_DATE_WINDOW.MAX_DAYS;
    },
  },
  methods: {
    onDateRangeInput(range) {
      if (!Array.isArray(range) || range.length < 2) return;
      const [start, end] = range;
      this.$emit('date-range-change', { start, end });
    },
  },
};
</script>
